import React, { useState, useEffect } from "react";
import "./review.css";

const reviews = [
  {
    name: "Rohit Sharma",
    role: "Small Business Owner, Delhi",
    text: "The loan process was quick and hassle-free. I got the funds I needed in no time. Highly recommended!",
  },
  {
    name: "Priya Mehta",
    role: "Freelancer, Mumbai",
    text: "Very transparent service and excellent support. The approval was faster than I expected.",
  },
  {
    name: "Ankit Verma",
    role: "Startup Founder, Bengaluru",
    text: "I was impressed by the professionalism and speed. The platform made borrowing so simple.",
  },
  {
    name: "Neha Gupta",
    role: "Homeowner, Pune",
    text: "The customer care team guided me at every step. Very reliable and trustworthy service.",
  },
];

const Review = () => {
  const [current, setCurrent] = useState(0);

  // Auto-slide every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % reviews.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="rev-section">
      <div className="rev-background"></div>
      <h2 className="rev-title">Testimonials</h2>

      <div className="rev-slider">
        {reviews.map((review, i) => (
          <div
            key={i}
            className={`rev-card ${i === current ? "active" : "inactive"}`}
          >
            <div className="rev-text">“{review.text}”</div>
            <div className="rev-name">{review.name}</div>
            <div className="rev-role">{review.role}</div>
          </div>
        ))}
      </div>

      <div className="rev-dots">
        {reviews.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === current ? "active" : ""}`}
            onClick={() => setCurrent(i)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default Review;
